/**
 * Sieve `Filters` query strings use commas between AND terms, pipes between OR alternatives
 * (e.g. `PermissionRoleId==1|2` for numeric equality with OR, or `AssignedDatabase@=RW_A|RW_B`
 * for string substring with OR), and parentheses to group OR'd field names for cross-column
 * filters (e.g. `(Username|FirstName)@=Brian`). Strip all of those structural characters from
 * user-provided operands so values cannot splice extra filter clauses, OR branches, or
 * unbalance the grouped-OR parens introduced for TROC-111.
 */
export function sanitizeSieveTermValue(value: string): string {
  return value.replace(/[,|()]/g, ' ');
}
